import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
  selector: "app-pagination",
  templateUrl: "./pagination.component.html",
  styleUrls: ["./pagination.component.scss"],
})
export class PaginationComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  @Input() currentPage: any;
  @Input() isNextDisabled: boolean = false;
  @Input() isPrevDisabled: boolean = false;

  @Output() nextPage = new EventEmitter<void>();
  @Output() prevPage = new EventEmitter<void>();

  next() {
    if (!this.isNextDisabled) {
      this.nextPage.emit();
    }
  }

  prev() {
    if (!this.isPrevDisabled) {
      this.prevPage.emit();
    }
  }
}
